import styled from 'styled-components';

import { Text } from '@gympass/yoga';

import commaOpacity from 'images/comma-opacity.png';

export const Container = styled.article`
  background: ${({ theme }) => theme.yoga.colors.white};
  box-shadow: 0px 4px 12px rgba(152, 152, 167, 0.25);
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  cursor: pointer;
`;

export const MainContent = styled.div`
  background: url(${commaOpacity}) no-repeat right top,
    linear-gradient(
      76.4deg,
      ${({ theme }) => theme.yoga.colors.primary} 0%,
      ${({ theme }) => theme.yoga.colors.primaryLight} 100%
    );
  border-radius: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  padding: ${({ theme }) => theme.yoga.spacing.medium}px;
  min-height: ${({ theme }) => theme.yoga.sizes.programCardHeaderHeight}px;
`;

export const Title = styled(Text.H4)`
  color: ${({ theme }) => theme.yoga.colors.white};
  font-size: ${({ theme }) => theme.yoga.fontSizes.large}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  padding-bottom: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.yoga.colors.white};
  font-weight: ${({ theme }) => theme.yoga.fontWeights.regular};
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  padding-bottom: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.yoga.spacing.xsmall}px
    ${({ theme }) => theme.yoga.spacing.small}px;
`;

export const ModulesCount = styled.p`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.regular};
  font-size: ${({ theme }) => theme.yoga.fontSizes.medium}px;
  color: ${({ theme }) => theme.yoga.colors.text.secondary};
`;

export const Label = styled.div`
  background-color: ${({ theme }) => theme.yoga.colors.feedback.success.light};
  font-weight: ${({ theme }) => theme.yoga.fontWeights.regular};
  font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
  border-radius: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
  padding: ${({ theme }) => theme.yoga.spacing.xxxsmall}px
    ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;
